/**
 * A debrief pick as the room reads it: addressed to the team by name (the room shows it to everyone, so "you" is no one) and without "pp" or "look-through".
 * The api writes both lines in the second person from its own facts; this is the one place they are put right until the pick carries the figure itself (wall: `DebriefPickView.gapRate`).
 */
import type { DebriefPickView } from "@bsim/contracts";

/** "You were …" → "Team X was …"; "your" → "its"; "you" → "the team". */
const addressTeam = (text: string, team: string): string => text
  .replace(/\bYour\b/g, `${team}'s`).replace(/\bYou were\b/g, `${team} was`).replace(/\bYou\b/g, team)
  .replace(/\byour look-through\b/g, "the next two years' forecast").replace(/\byour\b/g, "its").replace(/\byou\b/g, "the team")
  .replace(/beat the next two years' forecast/g, "look better than the next two years are forecast to be");

export const pickHeadline = (pick: Pick<DebriefPickView, "headline" | "teamName">): string => pick.headline.replace(/(\d)pp\b/g, "$1 points");
export const pickPrompt = (pick: Pick<DebriefPickView, "prompt" | "teamName">): string => addressTeam(pick.prompt, pick.teamName);
